export default __webpack_public_path__ + "static/media/mongodb.e14ccc89.png";